import { UserRole } from 'dy-frontend-http-repository/lib/data/enums';

// Role lists of the features which are gated by the signed-in user's role rather than by a
// permission. Kept free of any other import, so they can be evaluated on their own.

const adminAccessRoles = [UserRole.CORE_ROOT, UserRole.CORE_ADMIN, UserRole.CORE_PLATFORM_DEV];

// Kanban: roles the "Assigned to my team" filter is offered to (team membership is still required)
export const kanbanMyTeamFilterRoles = [
    ...adminAccessRoles,
    UserRole.CORE_PROJECT_MANAGER,
    UserRole.CORE_ART_DIRECTOR,
    UserRole.CORE_ASSISTANT_ART_DIRECTOR,
];

// Kanban: roles which open the board on "Assigned to my team" by default
export const kanbanMyTeamDefaultScopeRoles = [
    UserRole.CORE_PROJECT_MANAGER,
    UserRole.CORE_ART_DIRECTOR,
    UserRole.CORE_ASSISTANT_ART_DIRECTOR,
];

// Subscription: roles allowed to update the payment method (the permission is still required)
export const subscriptionPaymentMethodUpdateRoles = [...adminAccessRoles, UserRole.CORE_OPERATIONS_MANAGER];

// User settings: roles allowed to change the role of a core user
export const coreUserRoleChangeRoles = [
    ...adminAccessRoles,
    UserRole.CORE_OPERATIONS_MANAGER,
    UserRole.CORE_ACCOUNT_DIRECTOR,
    UserRole.CORE_CREATIVE_DIRECTOR,
    UserRole.CORE_HR,
];

// Work reports: roles allowed to report on behalf of another user
export const workReportActorSwitchRoles = [
    ...adminAccessRoles,
    UserRole.CORE_OPERATIONS_MANAGER,
    UserRole.CORE_ACCOUNT_DIRECTOR,
    UserRole.CORE_CREATIVE_DIRECTOR,
    UserRole.CORE_HR,
    UserRole.CORE_ACCOUNT_MANAGER,
];
